// Mobile menu burger toggle
const toggleBurgerMenu = () => {
    const burger = document.querySelector('.gh-burger');
    const ghSite = document.querySelector('.gh-site');
    burger.addEventListener('click', () => {
        ghSite.classList.toggle('is-head-open');
    });
};
toggleBurgerMenu();

// Add lightbox to gallery images
lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');

// Responsive video in post content
const reframeVideos = () => {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
};
reframeVideos();

// Theme Toggle Functionality
const handleThemeToggle = () => {
    const themeToggle = document.getElementById('theme-toggle');
    const htmlElement = document.documentElement;

    const sunIcon = document.getElementById('sun-icon');
    const moonIcon = document.getElementById('moon-icon');
    const lightFooter = document.getElementById('footer-powered-by-light');
    const darkFooter = document.getElementById('footer-powered-by-dark');

    const setTheme = (theme) => {
        htmlElement.setAttribute('data-color-pref', theme);
        localStorage.setItem('color-pref', theme);
        sunIcon.style.display = theme === 'dark' ? 'inline': 'none';
        moonIcon.style.display = theme === 'light' ? 'inline': 'none';
        lightFooter.style.display = theme === 'light' ? 'inline': 'none';
        darkFooter.style.display = theme === 'dark' ? 'inline': 'none';
    }

    themeToggle.addEventListener('click', () => {
        const currentTheme = htmlElement.getAttribute('data-color-pref');
        setTheme(currentTheme === 'dark' ? 'light' : 'dark');
    });
};
handleThemeToggle();

// Copy Link to Clipboard Functionality
const handleCopyLink = () => {
    const copyInput = document.getElementById('article-copy-link-input');
    const copyLinkIconBtn = document.querySelector('.copy-link-icon');

    if (copyInput) {
        copyInput.addEventListener('focus', () => copyInput.select());
    }

    if (copyLinkIconBtn) {
        copyLinkIconBtn.addEventListener('click', () => {
            copyInput.select();
            navigator.clipboard.writeText(copyInput.value);
        });
    }
};
handleCopyLink();

